import { TextFieldProps } from "@material-ui/core";
import { useFormContext } from "components/Form";
import { Input as InputComponent } from "components/Input";
import { Controller } from "react-hook-form";

type InputProps = TextFieldProps & {
  name: string;
  customLabel?: string;
};

export function Input(props: InputProps) {
  const {
    methodsForm: { control },
  } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const { ref, value, ...fieldProps } = field;
        return (
          <InputComponent
            customLabel={props.customLabel}
            {...props}
            {...fieldProps}
            value={value || ""}
            ref={ref}
          />
        );
      }}
    />
  );
}
